import { createFileRoute } from "@tanstack/react-router";
import { contactSessionsRoute } from "@/app-clients/provider-outreach-flow";

export const Route = createFileRoute("/api/kits/contact-sessions")({
    ...contactSessionsRoute,
});
